import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/ats/Desktop/cartoon-mango/docz-app-with-algolia-search/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "-dont-reset-on-setting-to-initial-state"
    }}>{`# Don't reset on setting to initial state`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-javascript",
        "metastring": "{.line-numbers}",
        "{.line-numbers}": true
      }}>{`import { HOC, commonConstants, store } from "react-boilerplate-redux-saga-hoc";

const TEST_API = {};
const REGISTER_API = {
  url: \`users/user-signup/\`,
  method: "POST",
};

const AuthenticationHOC = HOC({
  initialState: {
    profile: {},
  },
  dontReset: {
    REGISTER_API,
  },
  apiEndPoints: {
    TEST_API,
    REGISTER_API,
  },
  constantReducer: ({
    type,
    state,
    action,
    constants,
    initialState,
    resetState,
  }) => {
    if (type === "LOGOUT") return resetState; // it will only reset TEST_API to initial state
    return state;
  },
  name: "Auth",
});
/*
Example:

const { dispatch } = props;
dispatch({ type: 'LOGOUT' });
*/
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      